export enum EDirection {
  LEFT = 'left',
  RIGHT = 'right',
}

export type TDirection = 1 | -1;

export interface IArrowControls {
  isLeftButtonVisible?: boolean;
  isRightButtonVisible?: boolean;
  onButtonClick(direction: TDirection): void;
}
